import { render, staticRenderFns } from "./wallet-history-table.vue?vue&type=template&id=04fd048e&scoped=true"
import script from "./wallet-history-table.vue?vue&type=script&lang=js"
export * from "./wallet-history-table.vue?vue&type=script&lang=js"
import style0 from "./wallet-history-table.vue?vue&type=style&index=0&id=04fd048e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd048e",
  null
  
)

export default component.exports